import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class CustomService {
  entity: string = "/custom";

  constructor(private http: HttpClient, private authService: AuthService) {}

  dashboard(): Observable<any> {
    let profile = this.authService.currentUserValue.is_connect_with
      ? "?profile=" + this.authService.currentUserValue.profile.id
      : "";
    return this.http.get(
      environment.api + this.entity + "/dashboard" + profile,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  checkIssetAccount(body: any) : Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/check-isset-account",
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  sendPhoneConfirmation(body: any) : Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/send-phone-confirmation",
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  validate_reservation_passculture(code: string) : Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/validate-reservation-passculture/"+code,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  import(myFile: any): Observable<any> {
    const formData = new FormData();
    formData.append("files.my_file", myFile);
    return this.http.post(
      environment.api + this.entity + "/import-csv",
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
        },
      }
    );
  }

  send(body: any): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/send-notification",
      body,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  send_gift_email(body: any): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/send-gift-email",
      body,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  export_csv_file(body: any): Observable<any> {
    return this.http.post(environment.api + this.entity + "/export-csv", body, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
        "Content-Type": "application/json",
      },
    });
  }

  addUser(data: any): Promise<any> {
    return this.http
      .post(environment.api + this.entity + "/add-user", data, {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      })
      .toPromise();
  }

  generate_description_chatgpt(
    route: string,
    description: string
  ): Observable<any> {
    return this.http.post(
      environment.api + route,
      { description: description },
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  get_passculture_cookie(name: string) {
    let ca: Array<string> = document.cookie.split(";");
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, "");
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return "";
  }

  passculture_venues(body: any) {
    return this.http.post(
      environment.api + this.entity + "/passculture-venues",
      body,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  passcultures_reservations(params: any) {
    const q =
      "?url=" +
      environment.backend_passculture_pro +
      "&" +
      new URLSearchParams(params).toString();

    return this.http.post(
      environment.api + this.entity + "/passculture-reservations" + q,
      {},
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }
}
